module.exports = __webpack_public_path__ + "img/symphony_749_olive.b876bd27.jpg";